export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f7ab2abb3d72a355bb88723e339d330d0c9266987&name=fetchTypeahead!'